import { actionTypes } from '../../actions/tradevanCreate/donationCode';

export const initialState = {
  value: '',
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case actionTypes.SET_VALUE:
      return {
        ...state,
        value: payload,
      };
    default:
      return state;
  }
}
